document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('#berrigan-home');
  if (!root) return;
  var toggle = root.querySelector('.menu-toggle');
  var menu = root.querySelector('#bw-mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      toggle.querySelector('span').textContent = open ? '＋' : '−';
    });
    menu.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', function () { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.querySelector('span').textContent = '＋'; }); });
  }
  var membershipToggle = root.querySelector('.bw-membership-toggle');
  var signup = root.querySelector('#mc_embed_signup');
  if (membershipToggle && signup) {
    membershipToggle.addEventListener('click', function () {
      var open = membershipToggle.getAttribute('aria-expanded') === 'true';
      membershipToggle.setAttribute('aria-expanded', String(!open));
      signup.hidden = open;
      if (!open) signup.querySelector('input[type=email]').focus();
    });
  }
  var track = root.querySelector('.wine-track');
  var prev = root.querySelector('.bw-previous');
  var next = root.querySelector('.bw-next');
  if (track && prev && next) {
    var step = function () { var card = track.querySelector('.wine-card'); return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .8; };
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  var hero = root.querySelector('.hero');
  if (hero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-picture'));
    var activeSlide = 0;
    var slidePromises = [];
    var loadSlide = function (index) {
      if (slidePromises[index]) return slidePromises[index];
      var picture = slides[index];
      var source = picture.querySelector('source');
      var img = picture.querySelector('img');
      slidePromises[index] = new Promise(function (resolve) {
        if (!img) { resolve(false); return; }
        if (!img.dataset.src && img.complete && img.naturalWidth > 0) {
          resolve(true);
          return;
        }
        var settled = false;
        var fallbackTried = false;
        var timeout;
        var finish = function (loaded) {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          resolve(loaded);
        };
        var onLoad = function () { finish(img.naturalWidth > 0); };
        var onError = function () {
          // If a responsive WebP cannot load, try the original JPEG.
          if (!fallbackTried && source && source.getAttribute('srcset')) {
            fallbackTried = true;
            source.removeAttribute('srcset');
            img.src = img.dataset.src || img.getAttribute('src');
            return;
          }
          finish(false);
        };
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
        timeout = setTimeout(function () { finish(false); }, 10000);
        // Never overwrite the first slide with missing lazy-loading attributes.
        if (source && source.dataset.srcset) source.srcset = source.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.complete && img.naturalWidth > 0) onLoad();
      });
      return slidePromises[index];
    };
    var advanceHero = function () {
      if (document.hidden) {
        setTimeout(advanceHero, 1000);
        return;
      }
      var tryNext = function (step) {
        if (step >= slides.length) return Promise.resolve();
        var upcoming = (activeSlide + step) % slides.length;
        return loadSlide(upcoming).then(function (loaded) {
          if (!loaded) return tryNext(step + 1);
          slides[upcoming].classList.add('is-active');
          slides[activeSlide].classList.remove('is-active');
          activeSlide = upcoming;
        });
      };
      tryNext(1).then(function () {
        loadSlide((activeSlide + 1) % slides.length);
        setTimeout(advanceHero, 7000);
      });
    };
    if (slides.length > 1) {
      setTimeout(function () { loadSlide(1); }, 2500);
      setTimeout(advanceHero, 7000);
    }
  }

  var vineyardFrame = root.querySelector('.vineyard-video');
  if (vineyardFrame) {
    var clips = vineyardFrame.querySelectorAll('.vineyard-clip');
    var loadVineyardClips = function (count) {
      for (var i = 0; i < count; i++) {
        var source = clips[i].querySelector('source');
        if (source.dataset.src) {
          source.src = source.dataset.src;
          delete source.dataset.src;
          clips[i].load();
        }
      }
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      clips[0].controls = true;
      if ('IntersectionObserver' in window) {
        var stillVideoObserver = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            loadVineyardClips(1);
            stillVideoObserver.disconnect();
          }
        }, { threshold: .25 });
        stillVideoObserver.observe(vineyardFrame);
      } else {
        loadVineyardClips(1);
      }
    } else {
      var vineyardTimer;
      var vineyardFadeTimer;
      var vineyardActive = false;
      var vineyardInView = false;
      var vineyardGeneration = 0;
      var showVineyardClip = function (index) {
        if (!vineyardActive) return;
        var generation = vineyardGeneration;
        var incoming = clips[index];
        var outgoing = clips[1 - index];
        incoming.currentTime = 0;
        incoming.play().then(function () {
          if (!vineyardActive || generation !== vineyardGeneration) {
            incoming.pause();
            return;
          }
          vineyardFrame.classList.toggle('is-second', index === 1);
          clearTimeout(vineyardFadeTimer);
          vineyardFadeTimer = setTimeout(function () { outgoing.pause(); }, 750);
          vineyardTimer = setTimeout(function () { showVineyardClip(1 - index); }, index === 0 ? 6000 : 5000);
        }).catch(function () {
          vineyardFrame.classList.remove('is-second');
          clips[0].controls = true;
        });
      };
      var setVineyardActive = function (active) {
        if (vineyardActive === active) return;
        vineyardActive = active;
        vineyardGeneration++;
        clearTimeout(vineyardTimer);
        clearTimeout(vineyardFadeTimer);
        if (active) {
          loadVineyardClips(clips.length);
          showVineyardClip(0);
        }
        else {
          vineyardFrame.classList.remove('is-second');
          clips.forEach(function (clip) { clip.pause(); });
        }
      };
      if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          vineyardInView = entries[0].isIntersecting;
          setVineyardActive(vineyardInView && !document.hidden);
        }, { threshold: .25 });
        videoObserver.observe(vineyardFrame);
      } else {
        vineyardInView = true;
        setVineyardActive(!document.hidden);
      }
      document.addEventListener('visibilitychange', function () {
        setVineyardActive(vineyardInView && !document.hidden);
      });
    }
  }
  var vineyardImage = root.querySelector('.vineyard-image');
  if (vineyardImage) {
    var springImage = vineyardImage.querySelector('.vineyard-spring');
    var started = false;
    var startVineyardSequence = function () {
      if (started || !springImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      started = true;
      springImage.loading = 'eager';
      springImage.decode().catch(function () {}).then(function () {
        vineyardImage.classList.add('is-cycling');
      });
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          startVineyardSequence();
          observer.disconnect();
        }
      }, { threshold: .15 });
      observer.observe(vineyardImage);
    } else {
      startVineyardSequence();
    }
  }
});
